import GridSpinner from 'components/UI/GridSpinner'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { ROUTES } from 'constants/routes'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import PageHeader from 'components/PageHeader'
import { usePromisedPayment } from 'modules/Finance/PromisedPayment/hooks/usePromisedPayment'
import PromisedPaymentRequestForm from 'modules/Forms/Finance/PromisedPaymentRequest'
import validator from 'utils/asyncValidator'
import validationSchema from 'modules/Forms/Finance/PromisedPaymentRequest/validationSchema'
import { Redirect } from 'react-router-dom'

const Request = () => {
  const { t } = useTranslation()
  const pathGen = useGeneratePathI18n()

  const { settings: { available = false, loading = false, loaded = false, ...rest } = {} } =
    useSelector((state) => state['finance/promised-payment'])

  const { i18n } = useSelector(({ app }) => app)

  const { getSettings } = usePromisedPayment()

  useEffect(() => {
    getSettings()
  }, [i18n])

  if (!loaded || (!loaded && loading)) {
    return <GridSpinner />
  }

  if (loaded && !available) {
    return <Redirect to={pathGen(ROUTES.FINANCE_PROMISED_PAYMENT)} />
  }

  return (
    <>
      <div className={'layout-tile margin-bottom-16'}>
        <PageHeader className={'margin-bottom-24'}>
          {t('promised_payment::request.heading')}
        </PageHeader>

        <PromisedPaymentRequestForm
          creditSettings={{
            ...rest,
          }}
          initialValues={{ amount: rest?.min_amount ?? 0 }}
          asyncValidate={validator(validationSchema(rest))}
          onClose={() => global.history.go(-1)}
        />
      </div>
    </>
  )
}

export default Request
